import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

import * as api from '../../services/api/admin';

class AffiliateHomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliateId: props.affiliateId,
      correctAffiliateLink: true,
    };
  }
  async componentDidMount() {
    try {
      const affiliateLinkData = await api.checkAffiliateLinkExists(
        this.state.affiliateId
      );
      this.setState({ correctAffiliateLink: affiliateLinkData.exists });
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const { affiliateId, classes } = this.props;
    const { correctAffiliateLink } = this.state;

    if (!correctAffiliateLink) {
      return (
        <>
          <Typography className={classes.section2} variant="h4">
            Oops! There might be something wrong with your affiliate link.
            Please make sure the code has been copied correctly. Thanks for
            using Qwell!
          </Typography>
        </>
      );
    }
    return (
      <Grid
        container
        justifyContent="center"
        classes={{
          container: classes.root,
        }}
      >
        <Grid item xs={12} lg={8} xl={6}>
          <Paper className={classes.paper}>
            <Grid container direction="column" alignItems="center">
              <Grid item xs={12} classes={{ item: classes.section }} />

              <Grid item xs={12}>
                <Typography variant="h2" classes={{ root: classes.headerText }}>
                  Better Doctors. Insider Access. Free Concierge Service.
                </Typography>
              </Grid>

              <Grid item xs={12} classes={{ item: classes.sectionCenter }}>
                <Typography variant="h4">Sign up below to:</Typography>
              </Grid>

              <Grid item xs={12} classes={{ item: classes.section }}>
                <ul className={classes.list}>
                  <li>
                    <Typography variant="h6">
                      Get FREE access to Qwell concierge.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h6">
                      Access easy online scheduling.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="h6">
                      Enable your doctor to refer you to trusted doctors, as
                      needed.
                    </Typography>
                  </li>
                </ul>
              </Grid>

              <Grid
                item
                xs={6}
                classes={{ item: `${classes.section} ${classes.center}` }}
              >
                <Button
                  fullWidth
                  size="large"
                  color="primary"
                  variant="contained"
                  href={`/affiliate/sign-up/${affiliateId}`}
                  className={classes.button}
                >
                  Sign up
                </Button>

                <Typography variant="caption">
                  * At Qwell, we take data security very seriously, and do not
                  buy, sell, or share your data with any third party services.
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: '#002952 !important',

    fontSize: '1.2em',

    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  paper: {
    width: '100%',
    height: '100%',

    padding: '1.5em 5em',

    [theme.breakpoints.down('sm')]: {
      padding: '1.5em 1em',
    },
  },
  logoImage: {
    width: '223px',
    height: '52px',
  },
  section: {
    margin: '1em 0',
    fontSize: '1.7rem',
  },
  section2: {
    margin: '3em',
    fontSize: '1.7rem',
  },
  sectionCenter: {
    margin: '1em 0',
    fontSize: '1.7rem',
    textAlign: 'center',
  },
  headerText: {
    fontSize: '2.5em',
    fontWeight: 'bold',
  },
  list: {
    paddingLeft: '2em',
    fontSize: '1em',
  },
  center: {
    textAlign: 'center',
  },
  button: {
    marginTop: '2em',
    color: 'white !important',
    marginBottom: '3em',
  },
});

export default withStyles(styles)(withRouter(AffiliateHomePage));
